import { useState, useEffect } from 'react'

export const useOfferState = ({
  offer,
  client,
  tenant,
  startCountdown,
  setActivated,
  setIsUnderGap,
}) => {
  const [isAttrLoaded, setIsAttrLoaded] = useState(true)
  const [isSingleActivation, setIsSingleActivation] = useState(false)
  const [singleOfferActivated, setSingleOfferActivated] = useState(false)
  const [isUnlimitedReactivation, setIsUnlimitedReactivation] = useState(false)
  const [unlimitedOfferActivated, setUnlimitedOfferActivated] = useState(false)
  const [isFinalActivation, setIsFinalActivation] = useState(false)

  useEffect(() => {
    setIsAttrLoaded(false)
    // Check if the offer has time-bound activation
    if (
      offer?.activationRequired &&
      tenant?.tenantmasterconfig?.time_bound.enabled
    ) {
      // console.log('offer', offer)
      // Check if the offer has single activation
      if (
        offer.remainingActivations === 1 ||
        (offer.remainingActivations === 0 &&
          offer.activationStatus === 'Activated')
      ) {
        setIsFinalActivation(true)
      }

      if (offer.remainingActivations === -1) {
        setIsUnlimitedReactivation(true)
        if (offer.activationStatus === 'Activated') {
          setUnlimitedOfferActivated(true)
          setActivated(true)
        }
      }

      if (
        offer.remainingActivations === null &&
        offer.activationExpiry === null
      ) {
        setIsSingleActivation(true)

        // Explicitly check activation status
        if (offer.activationStatus === 'Activated') {
          setSingleOfferActivated(true)
          setActivated(true)
        }
      }
      // Check activation status from offer payload
      if (offer.activationStatus === 'Activated' && offer.activationExpiry) {
        startCountdown(offer.activationExpiry)
        setActivated(true)
        setIsUnderGap(false)
      } else if (offer.activationStatus === 'Expired') {
        if (
          offer.remainingActivations > 0 ||
          offer.remainingActivations === -1
        ) {
          startCountdown(offer.activationExpiry, true)
        } else {
          setActivated(false)
          setIsUnderGap(false)
        }
      }
    }
    setIsAttrLoaded(true)
  }, [offer, client, tenant, startCountdown, setActivated, setIsUnderGap])

  return {
    isAttrLoaded,
    isSingleActivation,
    singleOfferActivated,
    isUnlimitedReactivation,
    unlimitedOfferActivated,
    isFinalActivation,
    setUnlimitedOfferActivated,
    setSingleOfferActivated,
  }
}
